module.exports = __webpack_public_path__ + "img/mo_super01.69defeaa.png";